module.exports = __webpack_public_path__ + "static/media/OTA-overview.b014c1aa.png";